'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames6 = require('classnames');

var _classnames7 = _interopRequireDefault(_classnames6);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function Radio(props) {
    var _classnames2, _classnames3;

    var checked = props.checked,
        children = props.children,
        dataTn = props.dataTn,
        disabled = props.disabled,
        inputId = props.inputId,
        label = props.label,
        labelClass = props.labelClass,
        name = props.name,
        onChange = props.onChange,
        radioClass = props.radioClass,
        theme = props.theme,
        value = props.value,
        wrapperClass = props.wrapperClass;


    if (!theme) {
        return null;
    }

    var labelContainerClasses = (0, _classnames7.default)(theme.labelContainer, (0, _defineProperty3.default)({}, theme.labelContainerDisabled, disabled));
    var buttonClasses = (0, _classnames7.default)(theme.radioButton, radioClass, (_classnames2 = {}, (0, _defineProperty3.default)(_classnames2, theme.buttonDisabled, disabled), (0, _defineProperty3.default)(_classnames2, theme.buttonChecked, checked), _classnames2));
    var innerButtonClasses = (0, _classnames7.default)(theme.innerButton, (_classnames3 = {}, (0, _defineProperty3.default)(_classnames3, theme.innerButtonDisabled, disabled), (0, _defineProperty3.default)(_classnames3, theme.innerButtonChecked, checked), _classnames3));
    var labelClasses = (0, _classnames7.default)(theme.label, labelClass, (0, _defineProperty3.default)({}, theme.labelContainerDisabled, disabled));
    var childClasses = (0, _classnames7.default)(theme.children, (0, _defineProperty3.default)({}, theme.childrenDisabled, disabled));
    var id = inputId ? inputId : name + '-' + value.toString();

    return _react2.default.createElement(
        'div',
        { className: wrapperClass },
        _react2.default.createElement('input', {
            id: id,
            type: 'radio',
            name: name,
            value: value,
            checked: checked,
            disabled: disabled,
            onChange: function (_onChange) {
                function onChange(_x) {
                    return _onChange.apply(this, arguments);
                }

                onChange.toString = function () {
                    return _onChange.toString();
                };

                return onChange;
            }(function (e) {
                return onChange(value, e);
            }),
            className: theme.hiddenInput
        }),
        _react2.default.createElement(
            'label',
            {
                htmlFor: id,
                className: labelContainerClasses,
                'data-id': value,
                'data-tn': dataTn
            },
            _react2.default.createElement(
                'div',
                { className: buttonClasses },
                _react2.default.createElement('div', { className: innerButtonClasses })
            ),
            label && _react2.default.createElement(
                'div',
                { className: labelClasses },
                label
            )
        ),
        children && _react2.default.createElement(
            'div',
            { className: childClasses },
            children
        )
    );
}

Radio.displayName = 'Radio';

exports.default = Radio;


//////////////////
// WEBPACK FOOTER
// ./node_modules/dibs-elements/lib/Radio/index.js
// module id = ./node_modules/dibs-elements/lib/Radio/index.js
// module chunks = 4